import React from "react";
import Footer from "../Shear/Footer/Footer";
import Head from "../../layout/Head";
import Header from "../Shear/Header/Header";
import ScrollToTop from "../Shear/ScrollToTop";
import { Link } from "react-router-dom";
const TermsCondition = () => {
  return (
    <>
      <Head
        Title="Privacy Policy"
        href="/privacy-policy"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Contact Pages"
      />
      <Header />

      <div className="bg-gray-100">
        <section className="container mx-auto p-6 font-sans">
          <h1 className="text-3xl font-bold mb-8">Terms and Conditions</h1>
          <p className="mb-6">Effective Date: December 24, 2023</p>
          {/* Introduction section */}
          <h2 className="text-xl font-bold mb-4">Acceptance of Terms</h2>
          <p className="mb-6">
            By accessing or using the www.webnexit.com website ("Site") and the
            services provided by WebNex-IT ("Company"), you agree to comply with
            and be bound by the following terms and conditions ("Terms"). If you
            do not agree to these Terms, please do not use the Site or our
            services.
          </p>

          <h2 className="text-xl font-bold mb-4"> Services Offered</h2>
          <p className="mb-6">
            WebNex-IT offers online and offline freelancing courses, website
            design, and development services for freelancers, entrepreneurs, and
            businesses. The courses and services may be subject to specific
            terms and conditions, which will be provided separately.
          </p>

          <h2 className="text-xl font-bold mb-4"> Services Offered</h2>
          <p className="mb-6">
            WebNex-IT offers online and offline freelancing courses, website
            design, and development services for freelancers, entrepreneurs, and
            businesses. The courses and services may be subject to specific
            terms and conditions, which will be provided separately.
          </p>

          <h2 className="text-xl font-bold mb-4">User Accounts</h2>
          <p className="mb-6">
            To access certain features of the Site, you may be required to
            create a user account. You are responsible for maintaining the
            confidentiality of your account information and for all activities
            that occur under your account. You agree to notify WebNex-IT
            immediately of any unauthorized use of your account.
          </p>
          <h2 className="text-xl font-bold mb-4">Payment and Fees</h2>
          <p className="mb-6">
            Payment for courses, website design, and development services must
            be made in accordance with the pricing and payment terms specified
            on the Site. All fees are non-refundable unless otherwise stated.
          </p>
          <h2 className="text-xl font-bold mb-4">Intellectual Property</h2>
          <p className="mb-6">
            All content and materials on the Site, including but not limited to
            text, graphics, logos, images, and software, are the property of
            WebNex-IT or its licensors and are protected by intellectual
            property laws.
          </p>
          <h2 className="text-xl font-bold mb-4">Privacy Policy</h2>
          <p className="mb-6">
            Your use of the Site is governed by our Privacy Policy, which can be
            found at <Link to="privacy-policy">Privacy Policy</Link>. By using
            the Site, you consent to the terms of our Privacy Policy.
          </p>
          <h2 className="text-xl font-bold mb-4">Limitation of Liability</h2>
          <p className="mb-6">
            WebNex-IT reserves the right to terminate or suspend your access to
            the Site and services at any time for any reason. Upon termination,
            you must cease all use of the Site and services.
          </p>
          <h2 className="text-xl font-bold mb-4">Termination</h2>
          <p className="mb-6">
            WebNex-IT reserves the right to terminate or suspend your access to
            the Site and services at any time for any reason. Upon termination,
            you must cease all use of the Site and services.
          </p>
          <h2 className="text-xl font-bold mb-4">Governing Law</h2>
          <p className="mb-6">
            These Terms are governed by the laws of [Your Jurisdiction]. Any
            disputes arising under or in connection with these Terms shall be
            subject to the exclusive jurisdiction of the courts in [Your
            Jurisdiction].
          </p>

          <h2 className="text-xl font-bold mb-4">Contact Information</h2>
          <p className="mb-6">
            If you have any questions about these Terms, please contact us at
            infoitghor24@gmail.com or at the following address:
          </p>
          <p className="mb-8">
            WebNex-IT
            <br />
            Bornomala High School Road (Beside Donia College)
            <br />
            Nayapara, Jatrabari, Dhaka - 1236
            <br />
          </p>
        </section>
      </div>
      <ScrollToTop />
      <Footer />
    </>
  );
};

export default TermsCondition;
